export const GDL_COOKIES_DOMAIN = process.env.NEXT_PUBLIC_GDL_COOKIES_DOMAIN;

export function getCookie(key, options) {
  let decode =
      options && options.raw
        ? function (s) {
            return s;
          }
        : decodeURIComponent,
    pairs = document.cookie.split("; "),
    pair;

  for (let i = 0; i < pairs.length; i++) {
    pair = pairs[i];
    if (!pair) continue;

    pair = pair.split("=");
    if (decode(pair[0]) === key) return decode(pair[1] || "");
  }

  return null;
}

export function setCookie(key, value, options) {
  options = options || {};

  if (value == null) options.expires = -1;
  if (options.secure == null && typeof window !== "undefined" && window.location.protocol === "https:")
    options.secure = true;

  if (typeof options.expires === "number") {
    const days = options.expires;

    options.expires = new Date();
    options.expires.setDate(options.expires.getDate() + days);
  }

  value = String(value);

  const cookieValue = [
    encodeURIComponent(key),
    "=",
    options.raw ? value : encodeURIComponent(value),
    `; domain=${GDL_COOKIES_DOMAIN}`,
    `; path=/${options.path || ""}`,
    options.expires ? `; expires=${options.expires.toUTCString()}` : "", // use expires attribute, max-age is not supported by IE
    options.secure ? "; secure" : "",
  ].join("");

  document.cookie = cookieValue;

  return cookieValue;
}
